import {
  ExtendedFieldMappingEditorValue,
  transformSimpleValueInput,
} from '@components/text-editors/addons/field-mapping';
import { createPlaceholderHtml, createPlaceholderNode } from '@components/text-editors/helpers';
import { formatPhoneNumber } from '@utils/strings';

export const tag = 'phone-placeholder';

const attributes = ['value', 'label'];

export const getPlaceholderHtml = createPlaceholderHtml({ tag, attributes });

export const Phone = createPlaceholderNode({
  attributes,
  renderText: getPlaceholderHtml,
  tag,
});

export const transformInput = (input: ExtendedFieldMappingEditorValue[]) =>
  transformSimpleValueInput(input, (value) =>
    getPlaceholderHtml({
      value,
      label: formatPhoneNumber(value),
    }),
  );
